const PATH = 'fe.helpers.dimension';

const messages = {
  low: {
    key: `${PATH}.low`,
    defaultValue: 'Low'
  },
  mid: {
    key: `${PATH}.mid`,
    defaultValue: 'Mid'
  },
  high: {
    key: `${PATH}.high`,
    defaultValue: 'High'
  },
  notApplicable: {
    key: `${PATH}.not_applicable`,
    defaultValue: 'N/A'
  }
};

export default messages;
